module.exports = __webpack_public_path__ + "static/img/6.e6d49d1d.jpg";